/**
 * 这一期有多大比例进了奖池。
 *
 * <p><b>不读 `config.jackpotContribPct`。</b> 那是**当前**配置值，而入池比例
 * 运营在后台可调（V237）—— 同一天里前一期 25%、后一期 30% 是正常情况。
 * 把今天的配置贴到一期三个月前的账单上，用户拿金额一除就发现对不上，
 * 比不显示更伤。
 *
 * <p>后端也没有存逐期比例：`milhar_jackpot_ledger` 只有 `amount`，无比例列。
 * 所以拿这一期自己的两个数现算。两者同为 tier + currency + round 三者同域
 * （见后端 `MilharRoundDetailService` 的 ROUND_SQL / TOTALS_SQL），
 * 商就是这一期真正执行的比例，且与账单上方两行金额天然自洽。
 */

/** @returns 百分数（如 `25`）；无从计算时 `null`，调用方应当整行不渲染。 */
export function poolSharePct(
  amount: string | number | null | undefined,
  staked: string | number | null | undefined,
): number | null {
  // null/undefined 必须在 Number() 转换之前挡掉：`Number(null) === 0`，
  // 会被 s<=0 之外的分支当成「合法的 0」而不是「没有数据」，
  // 悄悄算出一个 0% 而不是不渲染。
  if (amount == null || staked == null) return null;
  const a = Number(amount);
  const s = Number(staked);
  if (!Number.isFinite(a) || !Number.isFinite(s)) return null;
  if (a < 0 || s <= 0) return null;
  return (a / s) * 100;
}

/**
 * 显示文本。
 *
 * <p>运营设的是 25 / 30 这类整数，金额按分存两位小数，商会落在整数附近而不
 * 正好等于它。差不到 0.2 个百分点就当整数——否则页面会冒出 `24,9%`，
 * 一个谁也没设过的数字。
 */
export function formatPoolSharePct(pct: number): string {
  const rounded = Math.abs(pct - Math.round(pct)) < 0.2
    ? Math.round(pct)
    : Math.round(pct * 10) / 10;
  return `${rounded}%`;
}
